// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ExpertisePage, LoginPage } from 'apps';
import { QRPage } from 'apps/qr';
import { RootState } from 'store';
import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Navigate, useLocation, Routes } from 'react-router-dom';
import { AdminPage, AdminPages } from 'apps/admin';
import {
  AdminBalancePage,
  AdminPackageManagementPage,
  AdminPriceListPage,
  AdminReportPage,
  AdminUserManagementPage,
  AdminAnnouncementsPage,
  AdminPanelPage,
  AdminExpertiseDictionaryManagementPage,
  AdminInquiriesPage,
  AdminInhouseCodeManagementPage,
  AdminProductPricePage,
  AdminTransactionsPage,
  AdminCampaignMatchingPage,
  AdminCampaignManagementPage,
  AdminEStoreManagementPage,
  AdminExpertiseMasterNoteManagementPage,
} from 'apps/admin/pages';
import { AdminExpertisePointsManagementPage } from 'apps/admin/pages/AdminExpertisePointsManagementPage';
import { AdminFinancialSummaryReportPage } from 'apps/admin/pages/AdminFinancialSummaryReportPage';
import { ProductShop } from 'components/ProductShop';
import { Orders } from 'components/Orders';

export const AppRoutes: React.FC = () => {
  const userInfo = useSelector((state: RootState) => state.auth.authUserInfo);
  const location = useLocation();

  return (
    <Routes>
      {/* QR Page - No authentication required */}
      <Route path="/qr" element={<QRPage />} />

      {!userInfo ? (
        /* Render auth page when user at `/auth` and not authorized. */
        <Route path="/auth/login" element={<LoginPage />} />
      ) : (
        /* Otherwise redirect to root page (`/`) */
        <Route path="/auth/login" element={<Navigate to="/" state={{ from: location }} replace />} />
      )}

      {!userInfo ? (
        <Route path="*" element={<Navigate to="/auth/login" state={{ from: location }} replace />} />
      ) : (
        <>
          <Route path="/admin" element={<AdminPage />}>
            {userInfo.isSuperAdmin || userInfo.isAdmin ? (
              <Route index element={<AdminBalancePage />} />
            ) : (
              <Route index element={<AdminPanelPage />} />
            )}
            <Route path={AdminPages.BALANCE} element={<AdminBalancePage />} />
            <Route path={AdminPages.REPORTS} element={<AdminReportPage />} />
            <Route path={AdminPages.USERS} element={<AdminUserManagementPage />} />
            <Route path={AdminPages.ANNOUNCEMENT} element={<AdminAnnouncementsPage />} />
            <Route path={AdminPages.PANEL} element={<AdminPanelPage />} />
            <Route path={AdminPages.INQUIRIES} element={<AdminInquiriesPage />} />
            <Route path={AdminPages.INHOUSE_CODE} element={<AdminInhouseCodeManagementPage />} />
            <Route path={AdminPages.FINANCIAL_SUMMARY_REPORT} element={<AdminFinancialSummaryReportPage />} />

            {userInfo.isSuperAdmin && (
              <>
                <Route path={AdminPages.TRANSACTIONS} element={<AdminTransactionsPage />} />

                <Route path={AdminPages.PRICE_LIST} element={<AdminPriceListPage />} />

                <Route path={AdminPages.PRODUCT_PRICE_LIST} element={<AdminProductPricePage />} />

                <Route path={AdminPages.PACKAGE_MANAGEMENT} element={<AdminPackageManagementPage />} />

                <Route path={AdminPages.EXPERTISE_POINT_MANAGEMENT} element={<AdminExpertisePointsManagementPage />} />

                <Route path={AdminPages.DICTIONARY} element={<AdminExpertiseDictionaryManagementPage />} />
              </>
            )}

            {(userInfo.isSuperAdmin || userInfo.isAdmin) && (
              <>
                <Route path={AdminPages.DICTIONARY} element={<AdminExpertiseDictionaryManagementPage />} />
                <Route path={AdminPages.MASTER_NOTE} element={<AdminExpertiseMasterNoteManagementPage />} />
                <Route path={AdminPages.CAMPAIGN_MATCHING} element={<AdminCampaignMatchingPage />} />
              </>
            )}

            {(userInfo.isSuperAdmin || userInfo.isAdmin) && (
              <>
                <Route path={AdminPages.CAMPAIGN_MANAGEMENT} element={<AdminCampaignManagementPage />} />
                <Route path={AdminPages.E_STORE} element={<AdminEStoreManagementPage />} />
              </>
            )}
          </Route>
          <Route path="/shop" element={<ProductShop />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="*" element={<ExpertisePage />} />
        </>
      )}
    </Routes>
  );
};
